import { render, staticRenderFns } from "./ListCargaFotoView.vue?vue&type=template&id=74005d9a&"
import script from "./ListCargaFotoView.vue?vue&type=script&lang=ts&"
export * from "./ListCargaFotoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports